<template>
  <v-card class="py-4 px-6">
    <v-card-title>{{ $t('partnerView.dealRegistration') }}</v-card-title>
    <v-card-text>
      <v-btn
        rounded
        color="success"
        :href="dealRegistrationFormUrl"
        target="_blank"
        rel="noreferrer"
        data-cy="partner-deal-registration-button"
      >
        {{ $t('partnerView.submitDeal') }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { PARTNER_DEAL_REGISTRATION_FORM_URL } from '@/constants/support'

export default {
  name: 'DealRegistration',
  data () {
    return {
      dealRegistrationFormUrl: PARTNER_DEAL_REGISTRATION_FORM_URL
    }
  }
}
</script>
